import SettingsInstance from './SettingsInstance';
import store from '../store/index';

var moment = require('moment');

const RENEW_TOKEN_MAX_ATTEMPTS = 3;
const CBO_CONTEXT_KEY = 'context';
const TOKEN_EXPIRATION_DATE_KEY = 'exp';
const ERROR_TYPE = {
  CBO_CONTEXT_NOT_FOUND: 1,
  CBO_CONTEXT: 2,
  SYSTEM_STATE: 3,
  AUTHENTICATION_CHECK: 4,
  READONLY_MODE: 5
};

const initialState = {
  email: null,
  organizations: null,
  organizationId: null,
  permissions: [],
  isAuthenticationChecked: false,
  isAnonymous: false,
  noOrganizations: false,
  noRoles: false,
  forestryManagementName: null,
  terytId: null,
  initializationError: false,
  globalError: false,
  globalErrorData: {
    message: null,
    code: null,
    signoutUrl: null
  },
  initialized: false,
  systemUnavailable: false,
  systemUnavailableMessage: null,
  systemUnavailableEndDate: null,
  readonly: false,
  readonlyMessage: null,
  tokenTimeoutId: null,
  tokenRenewalStartTime: null,
  tokenExpirationDate: null,
  csrfToken: null,
  termsOfUseError: false
};

const notLoggedUser = {
  email: 'Użytkownik niezalogowany',
  forestryManagementName: null,
  organizationId: 0,
  organizations: [
    { organizationId: 0, organizationName: 'Użytkownik niezalogowany' }
  ],
  roles: [{ permissions: ['Map_portal_access'], role_code: 'anon' }],
  terytId: null,
  isAnonymous: true,
  tokenExpire: 9562843255,
  type: 2
};

class Context {
  constructor() {
    this.state = { ...initialState };
  }
  get sameOrigin() {
    return SettingsInstance.baseUrl === window.location.origin;
  }

  getCsrfToken() {
    return this.state.csrfToken;
  }

  getTokenExpirationDate() {
    return parseInt(
      getStorageTokenExpirationDate() || this.state.tokenExpirationDate
    );
  }

  async login(redirect) {
    this._clearAll();
    //Option for dev- delete false for test
    if (
      SettingsInstance.baseUrl.includes('devpitmap.softcream') ||
      SettingsInstance.baseUrl.includes('localhost')
    ) {
      var ApiAuth = require('./api-auth.js').Api;
      let api = new ApiAuth();
      await api.getLoginTicket({}).then(() => {
        redirect = encodeURIComponent(redirect || window.location);
        window.location = SettingsInstance.baseUrl;
      });
      // this._clearAll();
      // redirect = encodeURIComponent(redirect || window.location);
      // window.location =
      //   SettingsInstance.baseApiUrl + '/authenticateWSO2?redirect=' + redirect;
    } else {
      redirect = encodeURIComponent(redirect || window.location);
      window.location =
        SettingsInstance.baseUrl +
        '/pit2/auth/SamlInit?returnUrl=' +
        SettingsInstance.baseUrl;
    }
  }

  getSignoutUrl() {
    // if (this.sameOrigin) {
    //   return (
    //     SettingsInstance.baseApiNewUrl +
    //     '/WSO2Signout?redirect=' +
    //     encodeURIComponent('/signout')
    //   );
    // }
    return SettingsInstance.baseApiAuth + '/SamlLogoutInit';
  }

  signout() {
    let wso2Signout = this.getSignoutUrl();
    this._clearAll();
    window.location = wso2Signout;
  }

  hasPermission(permissionId) {
    return (
      this.state.isAuthenticationChecked &&
      this.state.permissions &&
      this.state.permissions.has(permissionId)
    );
  }

  hasPermissionByRequiredPermissionIds(permissionIds) {
    return (
      !this._permissionRequired(permissionIds) ||
      !!permissionIds.find(x => {
        return this.hasPermission(x);
      })
    );
  }

  hasPermissionInReadonlyMode(readonlyDependent) {
    return !(readonlyDependent && this.readonly);
  }

  hasPermissionForLayer(layerDatasource) {
    if (!layerDatasource) return false;

    if (
      [
        'PUNKTOWA_ISTNIEJACA',
        'LINIOWA_ISTNIEJACA',
        'POWIERZCHNIOWA_ISTNIEJACA'
      ].includes(layerDatasource)
    ) {
      return (
        this.hasPermission('Edit_all_current_infrastructure_data') ||
        this.hasPermission('Edit_current_infrastructure_data')
      );
    } else if (
      [
        'PUNKTOWA_PLANOWANA',
        'LINIOWA_PLANOWANA',
        'POWIERZCHNIOWA_PLANOWANA'
      ].includes(layerDatasource)
    ) {
      return (
        this.hasPermission('Edit_all_planned_infrastructure_data') ||
        this.hasPermission('Edit_planned_infrastructure_data')
      );
    }
  }

  async init(payload) {
    let promises = [];

    if (!this.state.initialized || !this.state.isAuthenticationChecked) {
      this.state.isAuthenticationChecked = true;

      promises.push(
        this._fetchCboContext()
          .then(data => {
            this._setCboContext(data, true);
          })
          .catch(e => {
            this._oninitializationError(
              e.body && e.body.error && e.body.error.code === 'not_found'
                ? ERROR_TYPE.CBO_CONTEXT_NOT_FOUND
                : ERROR_TYPE.CBO_CONTEXT
            );
          })
      );
    }

    // promises.push(
    //   this._fetchSystemState()
    //     .then(data => this._setSystemState(data))
    //     .catch(e => {
    //       this._oninitializationError(ERROR_TYPE.SYSTEM_STATE);
    //     })
    // );

    await Promise.all(promises);

    this.state.initialized =
      this.state.isAuthenticationChecked &&
      (!this.state.initializationError || this.state.globalError);

    if (!this.state.initialized) {
      return false;
    }

    if (payload.onContextInitialized) {
      payload.onContextInitialized();
    }

    return true;
  }

  async changeContext(organizationId) {
    this._setCboContext(await this._fetchCboContext(organizationId));
  }

  _renewToken(renewId, attempt = 0) {
    let now = moment().unix();
    let inTokenRenewalTimeframe =
      now >= this.state.tokenRenewalStartTime &&
      now < this.getTokenExpirationDate();

    if (
      attempt < RENEW_TOKEN_MAX_ATTEMPTS &&
      inTokenRenewalTimeframe &&
      renewId === this.state.tokenTimeoutId
    ) {
      attempt += 1;
      this._fetchRenewToken({})
        .then(data => this._setTokenExpirationDate(data))
        .catch(_ => this._renewToken(renewId, attempt));
    }
  }

  _localStorageChanged(key, newValue, oldValue) {
    if (
      key === TOKEN_EXPIRATION_DATE_KEY &&
      newValue !== this.state.tokenExpirationDate
    ) {
      this._setTokenExpirationDate(newValue);
    }
    if (key === CBO_CONTEXT_KEY && newValue !== oldValue) {
      this._setCboContext(getStorageCboContext());
    }
  }

  _checkReadonlyMode() {
    var ApiReadonly = require('./api-tylko-do-odczytu.js').Api;
    let api = new ApiReadonly();

    return new Promise(function(resolve, reject) {
      api
        .getReadOnly({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        })
        .then(response => {
          resolve(response.body);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  async _fetchCboContext(organizationId) {
    var ApiAuth = require('./api-auth.js').Api;
    let api = new ApiAuth();
    let permissions = [];
    let data = {};
    try {
      let response = await api.GetUserOrganizations(
        {},
        { ignoreGlobalErrors: true }
      );

      data.noOrganizations = true;
      data.noRoles = true;

      let organization = undefined;

      if (response.body) {
        data.isAnonymous = false;
        data.noOrganizations = response.body.length === 0;

        if (organizationId) {
          data.organizationId = organizationId;
          localStorage.setItem('orgId', organizationId);
          organization = response.body.find(org => {
              return organizationId == org.organizationId;
            })
        } else {
          if (
            localStorage.getItem('orgId') &&
            response.body.some(org => {
              return localStorage.getItem('orgId') == org.organizationId;
            })
          ) {
            data.organizationId = Number(localStorage.getItem('orgId'));
            organization = response.body.find(org => {
              return localStorage.getItem('orgId') == org.organizationId;
            })
          } else if (response.body.length > 0) {
            organization = response.body[0];
            data.organizationId = organization.organizationId;
            localStorage.setItem('orgId', organization.organizationId);
          }
        }

        if (organization) {
          data.noRoles = organization.roleCount === 0;
        }

        permissions = await this.getUserPermissions(data.organizationId);
        if (permissions.body) {
          data.permissions = permissions;
        } else {
          notLoggedUser.roles.forEach(role => {
            if (role.permissions) {
              role.permissions.forEach(permission =>
                permissions.push(permission)
              );
            }
          });
          data.permissions = permissions;
        }

        data.forestryManagementName = null;

        data.terytId = 123;
        data.email = await this.GetUserEmail();
        data.organizations = response.body.map(organization => {
          return {
            organizationId: organization.organizationId,
            organizationName: organization.name
          };
        });
      } else {
        notLoggedUser.roles.forEach(role => {
          if (role.permissions) {
            role.permissions.forEach(permission =>
              permissions.push(permission)
            );
          }
        });
        data.isAnonymous = notLoggedUser.isAnonymous;
        data.permissions = permissions;
        data.organizationId = notLoggedUser.organizationId;
        data.forestryManagementName = notLoggedUser.forestryManagementName;
        data.terytId = notLoggedUser.terytId;
        data.email = notLoggedUser.email;
        data.organizations = notLoggedUser.organizations;
        data.tokenExpire = notLoggedUser.tokenExpire;
      }

      return data;
    } catch (error) {
      notLoggedUser.roles.forEach(role => {
        if (role.permissions) {
          role.permissions.forEach(permission => {
            permissions.push(permission);
          });
        }
      });
      data.isAnonymous = notLoggedUser.isAnonymous;
      data.permissions = permissions;
      data.organizationId = notLoggedUser.organizationId;
      data.forestryManagementName = notLoggedUser.forestryManagementName;
      data.terytId = notLoggedUser.terytId;
      data.email = notLoggedUser.email;
      data.organizations = notLoggedUser.organizations;
      data.tokenExpire = notLoggedUser.tokenExpire;
      return data;
    }
  }

  async getUserPermissions(orgId) {
    const ApiAuth = require('./api-auth.js').Api;
    const api = new ApiAuth();
    let permissions = [];
    try {
      const response = await api.getUserPermissions(
        { orgId: orgId },
        { ignoreGlobalErrors: true }
      );
      if (response.body) {
        permissions = response.body;
      } else {
        permissions = [];
      }
      return permissions;
    } catch (error) {
      this.getSignoutUrl();
    }
  }
  async GetUserEmail() {
    const ApiAuth = require('./api-auth.js').Api;
    const api = new ApiAuth();
    let email = [];
    try {
      const response = await api.GetUserEmail({}, { ignoreGlobalErrors: true });
      if (response.body) {
        email = response.body;
      } else {
        email = [];
      }
      return email;
    } catch (error) {
      this.getSignoutUrl();
    }
  }

  // _fetchSystemState() {
  //   var ApiAuth = require('./api-niedostepnosc-systemow.js').Api;
  //   let api = new ApiAuth();
  //   const vm = this;
  //   return new Promise(function(resolve, reject) {
  //     api
  //       .getNiedostepnoscAktualnyStan({
  //         wso2_id: vm.contextEmail,
  //         orgid: vm.contextOrganizationId
  //       })
  //       .then(function(response) {
  //         resolve(response.body);
  //       })
  //       .catch(function(error) {
  //         reject(error);
  //       });
  //   });
  // }

  _fetchRenewToken() {
    var ApiAuth = require('./api-auth.js').Api;
    let api = new ApiAuth();
    return new Promise(async function(resolve, reject) {
      api
        .getRenewToken({})
        .then(response => resolve(response.body.Expire))
        .catch(error => reject(error));
    });
  }

  _clearAll() {
    localStorage.clear();
    Object.keys(initialState).forEach(x => {
      this.state[x] = initialState[x];
    });
  }

  _permissionRequired(permissionIds) {
    return permissionIds && permissionIds.length;
  }

  _setTokenExpirationDate(data) {
    data = typeof data === 'string' ? parseInt(data) : data;
    if (data > this.state.tokenExpirationDate) {
      this.state.tokenExpirationDate = data;
      setStorageTokenExpirationDate(data);
      this._setTokenRenewalTimeout();
    }
  }

  _setTokenRenewalTimeout() {
    if (this.state.tokenTimeoutId) {
      clearTimeout(this.state.tokenTimeoutId);
    }

    let now = moment().unix();
    let secondsToTokenExpiration = this.getTokenExpirationDate() - now;
    let tokenRenewalStartTime = null;

    if (secondsToTokenExpiration > 0) {
      let min = null;
      let max = null;
      if (secondsToTokenExpiration < 60) {
        min = 0.55;
        max = 0.85;
      } else if (secondsToTokenExpiration < 300) {
        min = 0.65;
        max = 0.9;
      } else if (secondsToTokenExpiration < 7200) {
        min = 0.75;
        max = 0.9;
      } else {
        min = 0.85;
        max = 0.98;
      }
      let maxSeconds = secondsToTokenExpiration * max;
      let minSeconds = secondsToTokenExpiration * min;
      let secondsToTokenRenewal =
        Math.random() * (maxSeconds - minSeconds) + minSeconds;
      tokenRenewalStartTime = Math.floor(now + secondsToTokenRenewal);
      this.state.tokenTimeoutId = setTimeout(
        _ => this._renewToken(this.state.tokenTimeoutId),
        secondsToTokenRenewal * 1000
      );
    }

    this.state.tokenRenewalStartTime = tokenRenewalStartTime;
  }

  _setCboContext(data, saveInStorage = true) {
    data = data || {};
    this.state.organizationId = data.organizationId;
    this.state.permissions = new Set(data.permissions);
    this.state.forestryManagementName = data.forestryManagementName;
    this.state.terytId = data.terytId;
    this.state.email = data.email;
    this.state.organizations = data.organizations;
    this.state.isAnonymous = data.isAnonymous;
    this.state.noOrganizations = data.noOrganizations;
    this.state.noRoles = data.noRoles;
    this._setTokenExpirationDate(data.tokenExpire);
    localStorage.setItem('contextEmail', data.email);
    if (saveInStorage) {
      setStorageCboContext(data);
    }
  }

  _setSystemState(data) {
    data = data || {};
    this.state.systemUnavailable = !data.dostepnosc;
    this.state.systemUnavailableMessage = data.wiadomosc;
    this.state.systemUnavailableEndDate = data.zakonczenie;
  }

  _oninitializationError(errorType) {
    if (!this.state.initializationError) {
      this.state.initializationError = true;

      switch (errorType) {
        case ERROR_TYPE.CBO_CONTEXT_NOT_FOUND:
          this.setGlobalErrorData(403);
          break;
        default:
          // window.location = SettingsInstance.baseUrl + '/500';
          break;
      }
    }
  }

  clearGlobalError() {
    if (!this.state.termsOfUseError) {
      this.state.globalErrorData.signoutUrl = null;
      this.state.globalErrorData.code = null;
      this.state.globalErrorData.message = null;
      this.state.globalError = false;
    }
  }

  setGlobalErrorData(code) {
    this.state.globalErrorData.signoutUrl = this.getSignoutUrl();
    this.state.globalErrorData.code = code;
    this.state.globalError = true;

    switch (code) {
      case 403:
        this.state.globalErrorData.message = 'Brak uprawnień';
        break;
      case 404:
        this.state.globalErrorData.message = 'Nie znaleziono zasobu';
        break;
      case 500:
      default:
        this.state.globalErrorData.message =
          'System jest chwilowo niedostępny. Spróbuj ponownie później.';
        break;
    }
  }

  setTermsOfUseError(hasError) {
    this.state.termsOfUseError = hasError;

    if (this.state.termsOfUseError) {
      this.state.globalErrorData.signoutUrl = this.getSignoutUrl();
      this.state.globalErrorData.code = 500;
      this.state.globalError = true;
      this.state.globalErrorData.message =
        'System jest chwilowo niedostępny. Spróbuj ponownie później.';
    } else {
      this.clearGlobalError();
    }
  }

  getAnonymousePermissions() {
   return notLoggedUser.roles.reduce((acc, role) => {
      if (role.permissions && role.role_code === 'anon') {
        role.permissions.forEach(permission => acc.push(permission));
      }
      return acc;
    }, []);
  }
}

var getJwtObj = function(data) {
  if (data) {
    let parts = data.split('.');
    if (parts && parts.length > 1) {
      return JSON.parse(atob(parts[1]));
    }
  }
};

var getStorageCboContext = function() {
  let data = localStorage.getItem(CBO_CONTEXT_KEY);
  if (data) {
    return JSON.parse(decodeURIComponent(escape(atob(data))));
  }
};

var getStorageTokenExpirationDate = function() {
  return localStorage.getItem(TOKEN_EXPIRATION_DATE_KEY);
};

var setStorageCboContext = function(data) {
  localStorage.setItem(
    CBO_CONTEXT_KEY,
    btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  );
};

var setStorageTokenExpirationDate = function(data) {
  localStorage.setItem(TOKEN_EXPIRATION_DATE_KEY, JSON.stringify(data));
};

var getCookie = function(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = (cookies[i] || '').trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

const context = new Context();

window.addEventListener('storage', e =>
  context._localStorageChanged(e.key, e.newValue, e.oldValue)
);

export default context;
